import React from 'react';
import { observer } from 'mobx-react';
import { styled } from 'naan/stitches.config';
import __ from 'core/lib/localization';
import { Button } from 'naan/primitives/button';
import { VSpacer } from 'naan/primitives/spacer';
import { Text } from 'naan/primitives/text';
import { AppFactory } from '@app/app-factory';
import { resolveApiMessage } from '@core/models/user-manager/api-messages';
import { ToastService } from '@common/notifications/toast-service';
import { bugsnagNotify } from '@app/notification-service';

const TableNote = styled('div', {
  background: '$gray-25',
  borderRadius: '8px',
  padding: '$space$4',
  marginTop: '$space$5',
  whiteSpace: 'normal',
});

const NoBreak = styled('span', {
  wordBreak: 'break-all',
});

const ButtonsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column-reverse',

  '& > * + *': {
    margin: '$space$2 0 0 0',
  },

  '@small': {
    flexDirection: 'row',
    '& > * + *': {
      margin: '0 0 0 auto',
    },
  },
});

export const PendingEmailNote = observer(() => {
  const { userManager } = AppFactory.root;
  const { accountData } = userManager;
  const showNote =
    accountData.unconfirmedEmail; /*  || accountData.emailConfirmationRequired */

  const handleCancelPending = React.useCallback(() => {
    userManager.cancelPendingEmailChange().then(result => {
      // todo: consider consolitating to a fixed client-side confirmation message
      // current server possibilities:
      //   api.cancel_pending_email_change.email_reset
      //   api.cancel_pending_email_change.no_pending
      const message = resolveApiMessage(result);
      // const message = __('Previous email restored', 'previousEmailRestored');

      ToastService.open({
        message,
        type: 'success',
      });
    }, bugsnagNotify /* error toast? */);
  }, [userManager]);

  const handleResendEmail = React.useCallback(() => {
    userManager.resendEmailConfirmation().then(result => {
      const message = resolveApiMessage(result);
      // const message = __('Confirmation email sent', 'confirmationEmailSent');

      ToastService.open({
        message: message,
        type: 'success',
      });
    }, bugsnagNotify);
  }, [userManager]);

  if (!showNote) {
    return null;
  }

  if (accountData.unconfirmedEmail) {
    return (
      <TableNote>
        <Text textStyle={'small-text'}>
          {__('Pending verification', 'pendingVerification')}
          <br />
          <NoBreak as={'strong'}>{accountData.unconfirmedEmail}</NoBreak>{' '}
        </Text>
        <VSpacer size={2} />
        <Text textStyle={'small-text'}>
          {/* // @armando, is there a reasonable way to handle this? if not, let's not worry about the breaking */}
          {/* {__("We've sent an email to", 'weSentAnEmail')}{' '}
          <NoBreak>{accountData.unconfirmedEmail}</NoBreak>{' '}
          {__('with a link to confirm this email change.', 'withLinkToConfirm')}{' '} */}
          {__(
            "We've sent an email to %{email} with a link to confirm this email change.",
            'weveSentAnEmailToConfirmEmailChange',
            { email: accountData.unconfirmedEmail }
          )}{' '}
        </Text>
        <VSpacer size={4} />
        <ButtonsWrapper>
          <Button
            // todo: confirm if a toast is desireable here or not
            onClick={
              handleCancelPending /*userManager.cancelPendingEmailChange*/
            }
            label={__('Cancel', 'cancel')}
            size={'small'}
            presentation="cancel"
          />

          <Button
            onClick={handleResendEmail /*userManager.resendEmailConfirmation*/}
            label={__('Resend email', 'resendEmail')}
            size={'small'}
            presentation="secondary"
          />
        </ButtonsWrapper>
      </TableNote>
    );
  }

  /// This is not a feature anymore
  // if (accountData.emailConfirmationRequired) {
  //   return (
  //     <TableNote>
  //       <p>
  //         {__('Pending verification', 'pendingVerification')}
  //         <br />
  //         <NoBreak as={'strong'}>{accountData.unconfirmedEmail}</NoBreak>{' '}
  //       </p>
  //       <p>
  //         {__('We’ve sent an email to', 'weSentAnEmail')}{' '}
  //         <NoBreak>{accountData.unconfirmedEmail}</NoBreak>{' '}
  //         {__(
  //           'with a link to verify your account.',
  //           'withLinkToVerify'
  //         )}{' '}
  //       </p>
  //       <Button
  //         onClick={prevent(userManager.resendEmailConfirmation) as any}
  //         presentation="text-only"
  //         label={__('Resend email', 'resendEmail')}
  //         css={{ marginLeft: '-$$px' }}
  //       ></Button>
  //     </TableNote>
  //   );
  // }

  return null;
});
